module.exports = __webpack_public_path__ + "img/turntable-new.b7dd45fc.png";